module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("T WAS")])]), _vm._v(" warm and airless in the room, but not unbearably so. Outside on the bleached rolling miles of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("campos")]), _vm._v(", the heat of this July afternoon would be almost intolerable.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cassie waited. Her body felt damp with perspiration beneath the grey and cream linen suit she had worn for the journey from London to the vast Las Colinas Verdes estates in Andalusia.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The suit, understatedly elegant and deliberately so, had survived the flight and the taxi-ride out here well, she thought thankfully. No way had she wanted to present herself looking less than businesslike and in control.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She lifted a hand to check that her rich chestnut hair was tamed, severely anchored into the nape of her neck. And her heartbeats were steady—that was another consolation. There was no reason for them to be otherwise, of course; she was no longer a nervous, besotted bride of just twenty-one. She was three years older and a whole lot wiser.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_vm._v("Satisfied that her appearance was as good as it could get—given her average kind of looks—she glanced at her watch and wondered how much longer she would have to wait. The taxi that had brought ")]), _c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_vm._v("her from Jerez airport had deposited her here at the farmhouse over half an hour ago. The atmosphere in the heavily furnished, sombre room was beginning to stifle her, the louvres closed to keep out the merciless white heat of the sun.")])]), _c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I will send someone to tell your husband that you are here,’ her mother-in-law had stated. Doña Elvira had spoken politely; she always had, Cassie remembered, even when offering up her barbed insults, insults unfailingly echoed by her two older sisters, Roman’s aunts—Tía Agueda and Tía Carmela.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Is my son expecting you?’ A faint pinching of patrician nostrils had denoted that that lady had known Roman was not, that he had long since lost whatever interest he might once have had in his unsuitable, estranged wife.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No longer as frighteningly squashable as she once had been, Cassie had ignored the question and coolly stated, ‘I’ll wait. In the meantime, I’d like to see Roy. Perhaps you could send him to me.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And so she waited. Her disgraced twin brother, Roy, it transpired, was not available. He had been put to work erecting fences out on the estate, under the blistering sun, a part of the punishment that was only just beginning.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_vm._v("‘I’m under house arrest at Las Colinas Verdes, while Roman decides what to do with me,’ he’d complained during his distraught phone call of a couple of days ago. ‘I can’t face ten years in a Spanish jail, sis—I’d rather top myself!’ he’d added, his voice beginning to rise with panic. ‘You could persuade ")]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("Roman not to bring charges. He won’t listen to me. You know what he’s like—he’s got a tongue like a whip and a mind like a maze; you never know what he’s thinking! It makes it impossible to get through to him!’")])]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’ll phone him this evening,’ Cassie had reluctantly promised. She’d felt sick with disappointment over what her brother had done, the way he was dragging her into the mess he had made. ‘I’ll call him from the flat; the boutique’s busy right now.’ In fact, it was buzzing with bargain-hunters on the first day of their summer sale. Her boss and best friend, Cindy Corfield, had already gestured frantically to her to end this call and come up front to help out. ‘Though Roman isn’t likely to listen to me, either,’ she’d warned Roy, her voice tight. ‘If I ask him not to bring charges against you, he’ll probably do just the opposite to spite me. You shouldn’t have been such a damn fool in the first place!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I know, and I’m sorry—but for pity’s sake, sis, phoning him won’t help me! He’d just hang up on you—he’s rigid with pride, you know that! Come out here. He won’t be able to blank you then. He’ll listen to you—well, he’ll have to, won’t he? Damn it all, Cass, the guy’s still in love with you, even if you did walk out on him!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("Which was absurd. Roman Fernandez had "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("never")]), _vm._v(" loved her. He’d married her because it had been, for him, a matter of expediency at the time. And for her? She didn’t think about that, not ever. Three years ago she’d been naive and terribly vulnerable. Roman had ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("taken the tears from her eyes and replaced them with the stars that hadn’t lasted much longer than the actual wedding ceremony.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But she was a mature adult now and refused to dwell on past mistakes. And because she’d looked out for her volatile twin for most of her life she’d agreed to do as he’d begged. Roy probably didn’t deserve it, but she knew how frightened and alone he’d be feeling, so she’d give it her best shot and hope it would be good enough.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And so now she waited and refused to let herself fidget. During the forty-eight hours or so since she’d received her brother’s cry for help she’d worked out what she would offer in return for Roy’s freedom.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Offers only a hard-hearted brute could dismiss. She tried not to remind herself that that was exactly what Roman was, and against all her hopes and expectations her stomach flipped over when he finally walked into the room and closed the heavy panelled door behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was wearing a straight-brimmed black hat tipped forward over his eyes and the black denim of his shirt and jeans was covered in the dust of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("campos")]), _vm._v(". He brought the evocative scent of leather and maleness and white heat into the musty room that she knew from her long, lonely months spent here was never used, except as a repository for unwanted furniture.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("She had never tried to pretend that he wasn’t the most shatteringly fantastic-looking man she had ever seen, because that would have been pointless. But ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("hoping she looked in control, like a woman who had taken a long hard look at her life, edited out all the bad bits—in which he featured as the central character—and got on with her life, she dismissed the impact he made.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reminding herself that looks counted for nothing if they hid a hard, unloving heart, she rose to her feet. Five feet five inches of severely groomed adult woman, supported by three-inch spindly heels, was a match for any man, even if he was six feet something of steel-hard muscle and twelve years her senior.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘They told me you were here,’ Roman imparted in the husky, sexily accented voice that, despite everything, still had the power to send shivers careering up and down her spine. ‘I’m sorry to have kept you waiting.’ He removed his hat, and sent it languidly spinning across the room to land on a dour-looking table beneath one of the shuttered windows, revealing slightly overlong soft hair, as dark as the wing of a raven, and smoky charcoal-grey eyes that told her he wasn’t sorry at all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roman had never considered her feelings when they’d lived together. There was no reason on earth why he should do so now.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("‘So, what brings you?’ He tilted his head in enquiry, his ruthless, sensual mouth unsmiling, his dark eyes cold. ‘A year away, working in a second-rate dress shop in a little town that no one has ever heard of, living in a tiny, squalid flat above the premises, ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("has made you wake up to the fact that you’re far better off with your husband? Is that it?’")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His long legs were straddled, his thumbs hooked into the waistband of his jeans, his unforgettable features blanking out whatever thoughts were passing through his cold, cruel mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t want to look at him, but couldn’t avoid it without appearing to be a coward or, worse, shifty, as if she had something despicable to hide. And the burn of inner heat that pulsed so violently through her veins was anger, nothing else.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anger at his sarcastic denigration of her work, her home, the bitter knowledge that he must have kept tabs on her over the past twelve months without her being aware of it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not willing to waste breath on telling him that the boutique she ran with Cindy was thriving, that the flat above the premises might be small but was light years away from being squalid, she made her features as cool and unreadable as his and told him, ‘I came because Roy’s in trouble and he needs me.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Now, I wonder why that fails to surprise me.’ The words were drawled, casually sardonic, but a flicker of some dark emotion over his harshly beautiful features and the thinning of his aristocratic nostrils told her she had somehow hit a nerve.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("She narrowed her tawny eyes at him, waiting for some further reaction, something she might be able to use to her advantage. And when none came, and there was nothing but the thick, uncomfortable silence, she returned to the straight-backed heavily ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("carved chair and lowered herself into its unforgiving embrace.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Slowly, she crossed her long silk-clad legs and watched him watching the unconsciously elegant, vaguely provocative movement; she realised with a tiny shock that made her breath catch in her lungs that his brooding eyes had taken in the way her narrow skirt had ridden way above her knees and quite definitely liked what they saw.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sex. She would not let herself think about that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She said levelly, refusing to let him see how nervous she had suddenly become, ‘I understand how angry you must be with Roy. I feel exactly the same. What he did was nothing short of disgraceful.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Then for once in our lives, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mi esposa")]), _vm._v(", we are in agreement.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Smooth, cool, even very faintly amused, his riposte didn’t help. Twisting her fingers together, she pulled in a breath. ‘But sending him to prison wouldn’t help; you must see that. It would blight the rest of his life—he is only twenty-four…and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do")]), _vm._v(" remember the hallowed Fernandez name.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("A bite in her voice there. She hadn’t been able to help it. Pride in their exalted ancestry, the ownership of vast tracts of land supporting vines, cattle, wheat and olives, their place in society as members of one of the old sherry families, had been the favourite, seemingly endless topic of conversation between Don˜a Elvira and the aunts. Indulged in, she had no doubt at all about it, to reinforce their opinion that ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("she was nowhere near good enough to be the wife of the heir to the kingdom!")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You are suggesting that his crime goes unpunished?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Roman was moving now, with the indolent grace that was so characteristic of him, his wide hard shoulders relaxed, his lean body tapering down to flat, narrow hips and endless legs. He opened the louvres, letting the harsh light flood the room. Probably the better to see her, she thought tiredly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stood with his back to the windows, his face shadowed. Enigmatic. So what else was new? She had never been able to tell what he was thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But that didn’t matter. He was nothing to her now. She had walked out on their empty marriage a year ago and after another year she could begin divorce proceedings. All she cared about was helping her brother out of this mess and then getting back to England.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘If you don’t bring charges against him, I’ll take him back home with me—that could be a condition.’ She offered the solution she had been turning over in her mind ever since Roy had phoned her. ‘Leaving Spain permanently would be punishment enough. He loves this country.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I don’t think so,’ Roman replied implacably. ‘What he loves about Spain is being connected by your marriage to one of the wealthiest families in Andalusia. It makes him feel important.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Cynic! Cassie swallowed the instinctive accusation. Why waste her time and her breath on stating ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("the obvious? He had married her for purely cynical reasons and nothing had changed.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grimly, she refused to let memories eat away at the poise she had gathered during her year away from her unloving husband and his incurably snobbish family. She was over whatever it was that she had once felt for him and was making a life for herself where she was respected and liked, and where no one tried to make her feel inferior.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She straightened her already rigid shoulders, mentally crossed her fingers, and played her ace. ‘Do you really want that sort of blot on the revered family name? Somehow, I don’t think so. Imagine the gossip when it becomes known that Roman Fernandez’s brother-in-law is behind bars.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He moved into her line of vision, standing over her, his height, his breadth, the power of him suddenly and unwelcomingly intimidating.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The sympathy would all be with my family for its association with yours. We would be seen as upholding the rule of law, no matter what the cost. Quite noble, you must agree.’ He smiled, but his eyes were still cold and hard. ‘You will have to do better than that.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cassie muffled a sigh and reined back the urge to slap that beautiful, arrogant face. There was no point in appealing to his better nature. Still less point in trying to get through to him. She had never been able to do that, not even when they were first married.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("‘I’ll repay every peseta he stole from you,’ she offered without a great deal of hope. She had no idea ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("how much that was—Roy, to put it mildly, had been incoherent on that subject. It could take her the rest of her life, but it would be worth it. She lifted eyes to him that were now sparkling with defiance—she refused to admit that the emotion raging inside her was hurt—and said, ‘You’ll get your money back, get me and Roy out of your sight. In a year we can divorce and you can forget your precious family was ever associated with mine! And then—’ she drew in a breath, surprised by the pain that gripped her heart in a cruel vice ‘—you can marry that highly suitable Delfina who was always hanging around. Make your mother and the aunts happy—Delfina, too. The way she flirted with you, and the way you played up to her, used to make me sick!’")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Too late, she deeply regretted the unguarded words that had revealed some of those earlier painful insecurities. She was over them now; she didn’t care who he eventually married. But his ego was too large to let him believe that simple fact, as was clearly demonstrated by the upward drift of one dark brow, the knowing tilt of his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He thought she was jealous, that she still felt something for him. It was intolerable!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cassie shot to her feet, smoothing the non-existent wrinkles out of her skirt with unsteady hands. She was beginning to get a headache and her stomach was tying itself in tense knots because, so far, her visit hadn’t achieved a thing except to remind herself of two of the most unhappy years of her life.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still, she had to try. She tilted her chin. ‘Do we have a deal?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She couldn’t plead with him, not even for her twin’s sake. She had pleaded with Roman too often in the past—to no effect whatsoever—to want to go through that humiliating experience again, to put her pride on the line for him to trample on.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No,’ he said implacably. ‘At least, not the one you outline. You surprise me, Cassandra,’ he added, as if he questioned her sanity. ‘When we married I found work for your brother in the Jerez accounts office because, according to him, he didn’t want to cut the apron strings and go back to England without you and he didn’t want to follow in your father’s footsteps and study medicine. In fact he almost shed tears when I reminded him that that was what his father had wanted.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He was barely twenty-one and he didn’t know what he wanted to do with his life. He’d not long lost his father, had had to face the fact that the family home had to be sold to pay Dad’s debts—and, unlike you, he hadn’t come into this world cushioned by money and holding the entrenched belief that he was superior to everyone else on the planet!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("He ignored her protective outburst as if the heated words had never been said, just as he had ignored every opinion, every need of hers, in the past. ‘I gave Roy a job with a living wage, then paid the rent on an apartment because after a while he complained that he wanted to be independent of the family household in Jerez. He repaid me by going in to the ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("office late and leaving early—when he bothered to go at all—and finally betrayed me and my family by embezzling a not insubstantial amount of money.’ He lifted his shoulders in a dismissive shrug, as if the conversation was beginning to bore him. ‘Having you rescue him from the consequences of his crime and repay the money he stole would not build his character, I think.’")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cassie winced. She hated to admit it, but in a way he was right. But she knew her brother far better than Roman did, and a spell in prison wouldn’t help Roy achieve responsible adulthood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She put her fingers to her temples. The pain was getting worse. She’d made this journey, come face to face with Roman again, had the humiliation of seeing her offer brushed aside as if it had been made by a fool, and accomplished precisely nothing. She felt as if she’d been chewed up and spat out, and it wasn’t a pleasant sensation. She pushed herself to her feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘If that’s your final word, I’ll leave, but I’d like to see Roy before I go,’ she said thickly. ‘I’ll wait here until he finishes work.’ Surely he couldn’t be heartless enough to deny her that? She had to see her twin, let him know she’d done her best. Advise him to take his punishment like a man and tell him to come back to England, to her, when he was free, and she’d do everything she could to help him to make a fresh start.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("‘And here was I, beginning to think you’d devel")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("oped a backbone,’ he said lightly. ‘I think you give up too easily.’")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Perspiration was slicking her skin and she folded her arms jerkily across her chest as she tried to contain the feeling that she was about to have hysterics. ‘And I think you don’t know what you’re talking about,’ she said, hanging on to what little poise she had left. ‘You won’t listen to what I have to say so what am I supposed to do? Sit in my chair like a good little girl until I grow roots?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I listened,’ Roman remarked with an indolence that made her hackles rise.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She felt her face go red. ‘Maybe. But you still refused to consider what I said!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I wasn’t aware that it was mandatory.’ One broad shoulder lifted in a very slight shrug.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was impossible! Swallowing fury, she hitched the strap of her bag over her shoulder. She was leaving! But easier said than done, because a graceful long-legged stride, one hand on her arm, stopped her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t want him touching her. The heat of his hand through the fine fabric of her sleeve brought back memories she had no desire to acknowledge. Her tongue, though, was welded to the roof of her mouth and, before she could unstick it, he said at a smooth tangent, ‘You’ve gained weight. For most of our two years together you reminded me of a stick. Sometimes I used to worry about you.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What a lie! Concern for her happiness and well-being had been so low on his list of priorities it had fallen off the bottom of the paper!")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Liar!’ she accused scornfully. ‘The only people who worried about my weight loss were your mother and aunts. And that, according to the precious Delfina, was because they thought I was anorexic and possibly infertile. She even told me that having your child was the only way they would ever accept me.’ Seized by a wild, uncontrollable anger, she surged on, ‘I should have told them that I lost weight because I was desperately unhappy. That I couldn’t conceive because you never came near me!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The words blistered her mouth but she didn’t regret them. It was time Roman faced the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I thought you didn’t want me to?’ The sensual line of his mouth tightened. ‘You rejected me, or don’t you remember?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was framed as a question but he’d wait until hell froze over before he got an answer. She’d die before she admitted how much she’d regretted pushing him away, turning from him, lacking the courage to tell him how she felt; how later she’d ached for his touch; how his indifference, his long absences had hurt her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("She thinned her mouth as, probably in retaliation for her stubborn silence, glittering charcoal eyes veiled by thick black lashes made a lazy inventory of the curves she privately thought had grown a little too lush just lately. Her body burned hotly where his eyes touched and she tried to squirm away, aware that her breath was thick in her throat. His unanswered question and the explicitly intimate way he ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("was looking at her was beginning to fill her with embarrassment and confusion.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What did he know about how she had felt? The sense of inadequacy, the beginnings of the shame that had grown right throughout their marriage because he had obviously decided she was frigid, not worth the trouble of going to her room at night.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His fingers tightened on her arm, his other hand resting lightly on her waist, just above the feminine roundness of her hips; his voice was sultry and wicked as he asked, ‘I wonder if a year apart has made any difference? Perhaps we should try to find out. Would you still reject me if I came to you in the night?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Don’t!’ It was wrenched from her. She went rigid. She had taught herself not to cry; she wasn’t going to forget those harsh lessons and disgrace herself now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Once—it seemed like a lifetime ago now—she had thought she loved him, had worshipped him, believed him to be the most perfect being ever to draw breath.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now she knew better. He couldn’t get to her on any level if she didn’t let him. She threw back her head and challenged him, ‘If you think I’m going to oblige you, lie down on the floorboards while you satisfy your sexual curiosity, then you can think again!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("She slapped his hands away, one after the other, and headed for the door, her lips clamped together to stop herself screaming with all the remembered pain, and he drawled behind her, ‘I had something ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("rather more civilised in mind, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mi esposa")]), _vm._v(". Share my bed for the next three months and satisfy my…sexual curiosity, and I won’t bring charges against your brother.’")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page20"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9063334c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459202894_ch01.vue
// module id = 69
// module chunks = 0